<template>
  <el-container class="Company">
    <el-main>
      <div class="page-title">{{ title }}</div>
      <el-form
        class="pb-20"
        ref="form"
        :model="data"
        :rules="rules"
        label-width="90px"
        inline
      >
        <el-card class="box-card" style="width:50%">
          <div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="회사명" prop="name">
                  <el-input v-model="data.name" maxlength="20" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="대표자" prop="owner">
                  <el-input v-model="data.owner" maxlength="10" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="전화번호" prop="tel">
                  <el-input v-model="data.tel" maxlength="20" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="팩스번호" prop="fax">
                  <el-input v-model="data.fax" maxlength="20" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="주소" prop="addr">
                  <el-input v-model="data.addr" maxlength="30" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="이메일" prop="email">
                  <el-input v-model="data.email" maxlength="50" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="계좌번호" prop="bank">
                  <el-input v-model="data.bank" maxlength="30" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="사업자번호" prop="crn">
                  <el-input v-model="data.crn" maxlength="50" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="업태" prop="conditions">
                  <el-input v-model="data.conditions" maxlength="25" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="종목" prop="item">
                  <el-input v-model="data.item" maxlength="25" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-card class="box-card mt-20" style="width:50%">
          <div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="상단 색상" prop="style">
                  <el-color-picker
                    v-model="data.style"
                    :predefine="predefineColors"
                  /> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="거래 명세서 일자 출력" prop="invoice_type">
                  <el-select
                    v-model="data.invoice_type"
                    placeholder="거래 명세서 일자"
                  >
                    <el-option
                      v-for="item in invoice_type_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="거래 명세서 인쇄 타입" prop="income_trade_print_type">
                  <el-select
                    v-model="data.income_trade_print_type"
                    placeholder="거래 명세서 일자"
                  >
                    <el-option
                      v-for="item in print_type_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select> </el-form-item
              ></el-col>
              <el-col :span="6">
                <el-form-item label="거래 명세서 합계 표기" prop="is_total">
                  <el-checkbox
                    v-model="data.is_total"
                    name="is_total"
                  ></el-checkbox> </el-form-item
              ></el-col>
              <el-col :span="6">
                <el-form-item label="거래 명세서 현장 표기" prop="income_trade_print_field">
                  <el-checkbox
                    v-model="data.income_trade_print_field"
                    name="income_trade_print_field"
                  ></el-checkbox> </el-form-item
              ></el-col>
              <el-col :span="6">
                <el-form-item label="거래 명세서 평 합계 표기" prop="income_trade_print_pyung">
                  <el-checkbox
                    v-model="data.income_trade_print_pyung"
                    name="income_trade_print_pyung"
                  ></el-checkbox> </el-form-item
              ></el-col>
              <el-col :span="6">
                <el-form-item label="유리 평단가, 가공비 표기" prop="show_pyung_processing_cost">
                  <el-checkbox
                    v-model="data.show_pyung_processing_cost"
                    name="show_pyung_processing_cost"
                  ></el-checkbox> </el-form-item
              ></el-col>
            </el-row>
          </div>
        </el-card>
      </el-form>
    </el-main>
    <el-footer>
      <div>
        <el-button
          type="primary"
          size="mini"
          :disabled="!has_grant_write"
          @click="handleClickModify()"
          >수정</el-button
        >
      </div>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import { authority_level } from "@/common/mixins/authority_level";
import { company_info } from "@/common/mixins/company_info";

export default {
  name: "Company",
  mixins: [authority_level, company_info],
  data() {
    return {
      title: this.$t("title.company"),
      rules: {
        name: [
          { required: true, message: "회사명을 입력하세요.", trigger: "blur" },
        ],
        owner: [
          {
            required: true,
            message: "대표자명을 입력하세요.",
            trigger: "blur",
          },
        ],
        conditions: [
          { required: true, message: "업태를 입력하세요.", trigger: "blur" },
        ],
        email: [
          {
            required: true,
            type: "email",
            message: "올바른 메일 주소를 입력해 주세요.",
            trigger: "blur",
          },
        ],
      },
      data: {
        name: "",
        addr: "",
        tel: "",
        fax: "",
        bank: "",
        owner: "",
        email: "",
        crn: "",
        conditions: "",
        item: "",
        style: "",
        invoice_type: "trading",
        income_trade_print_type: "portrait",
        is_total: false,
        income_trade_print_field: false,
        income_trade_print_pyung: false,
        show_pyung_processing_cost: false
      },
      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
      ],
      invoice_type_options: [
        {
          value: "order",
          label: "수주일",
        },
        {
          value: "trading",
          label: "매출일",
        },
      ],
      print_type_options: [
        {
          value: "portrait",
          label: "세로(기본)",
        },
        {
          value: "landscape",
          label: "가로",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["table_config"]),
    has_grant_write() {
      return this.isWriteLevel("company");
    },
  },
  watch: {
    table_config() {
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let item = this.loadCompanyConfig();
      if (!item) {
        return;
      }
      this.util.copyObject(item.value, this.data);
    },
    handleClickSave() {
      this.updateCompanyGlobalConfig(this.data, this.handleResponse);
    },
    handleResponse(res) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, "저장되었습니다.");
    },
    handleClickModify() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.handleClickSave();
      });
    },
  },
};
</script>
<style lang="scss">
.Company {
  .el-input__inner {
    width: 250px;
  }
}
</style>
